import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const Search:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M17.5 18.4155L14.5834 15.4989M16.6667 10.4989C16.6667 14.4109 13.4954 17.5822 9.58333 17.5822C5.67132 17.5822 2.5 14.4109 2.5 10.4989C2.5 6.58684 5.67132 3.41553 9.58333 3.41553C13.4954 3.41553 16.6667 6.58684 16.6667 10.4989Z" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
